import { render, staticRenderFns } from "./resume-name.vue?vue&type=template&id=40423850"
import script from "./resume-name.vue?vue&type=script&lang=js"
export * from "./resume-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports